







import { Component, Prop, Vue } from 'vue-property-decorator';
import IntegrationDto from '@/models/Integrations/IntegrationDto';
import IntegrationSystemIdConstants from '@/models/Integrations/IntegrationSystemIdConstants';

@Component({
  name: 'IntegrationLogo'
})
export default class IntegrationLogo extends Vue {
  @Prop({ required: true }) readonly integrationId!: string;
  @Prop({ default: '32px' }) readonly size!: string;
  @Prop({ default: 'integration-logo-img' }) readonly logoClass!: string;
  @Prop({ default: 'Integration Logo' }) readonly altText!: string;

  get logoUrl(): string {
    try {
      return require(`@/assets/img/integrations/${this.integrationId}.png`);
    } catch (e) {
      // If the logo file doesn't exist, return undefined
      return undefined;
    }
  }

  get hasLogo(): boolean {
    return !!this.logoUrl;
  }

  get logoStyle(): object {
    return {
      width: this.size,
      height: this.size,
      display: 'inline-flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    };
  }
}
